// store.js
import { create } from "zustand";

type ModalInstance = any; // 혹은 더 구체적인 타입으로 정의할 수 있습니다.

interface ModalStackStoreType {
  modals: ModalInstance[];
  addModal: (modal: ModalInstance) => void;
  removeModal: (modal: ModalInstance) => void;
  getTopModal: () => ModalInstance | undefined;
}

/**
 * @field modals : 모달 스택
 * @field addModal : 모달 스택에 추가
 * @field removeModal : 모달 스택에서 제거
 * @field getTopModal: 모달 스택 중 제일 위에있는 모달을 가져옴
 *
 * @author c_bae
 * @description 모달이 하나가 아닌 여러개가 출력되는 UI가 있어 모달스택으로 ESC 입력 시 최상위 모달일때만 닫히도록 처리하기 위해 해당 Store를 만듦
 * @tutorial
 * 마운트 될 때 addModal로 modals에 추가,
 * 언마운트 될 때 removeModal로 modals에서 제거,
 * 현재 떠있는 모달 중 가장 위에 있는 모달ref( getTopModal ) 이 닫으려는 모달 ref와 같은지 체크
 */
const useModalStackStore = create<ModalStackStoreType>((set, get) => ({
  modals: [],
  addModal: (modal) => set((state) => ({ modals: [...state.modals, modal] })),
  removeModal: (modal) =>
    set((state) => ({ modals: state.modals.filter((m) => m !== modal) })),
  getTopModal: () => {
    const { modals } = get();
    return modals[modals.length - 1];
  },
}));

export default useModalStackStore;
